import { Injectable } from "@angular/core";
import { BaseFacade } from "@webapp/core/abstracts/services/base-facade.service";
import { WhiteboardsApiService } from "./whiteboards-api.service";
import { WhiteboardsState } from "@webapp/whiteboards/services/whiteboards-state.service";
import { Whiteboard, WhiteboardDto } from "@webapp/whiteboards/models/whiteboard.models";

@Injectable({
  providedIn: "any",
})
export class WhiteboardsFacade extends BaseFacade<Whiteboard, WhiteboardDto, WhiteboardsState, WhiteboardsApiService> {
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(state: WhiteboardsState, api: WhiteboardsApiService) {
    super(state, api);
  }
}
